import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  animatedVideoIcon,
  socialMediaVideoIcon,
  youtubeVideoIcon,
  corporateVideoIcon,
  tutorialVideoIcon,
} from "../../../../assets/icons/serviceIcon/index";
import PodcastVideoContent from "./PodcastVideoContent";
import { text } from "stream/consumers";

const items = [
  {
    name: "Audio & Visual Cleanup",
    text: "Remove background noise, awkward pauses, filler words and visual distractions to ensure a clean and pleasant viewing or listening experience",
  },
  {
    name: "Multi-Cam & Split-Screen Edits",
    text: "Sync and switch between camera angles for interviews or remote recordings, keeping the flow natural and visually engaging throughout",
  },
  {
    name: "Audio Cleanup & Enhancement",
    text: "Remove background noise, echo, and uneven levels. Balance voices, enhance clarity, and make sure every word sounds clean and professional.",
  },
  {
    name: "Platform-Ready Video Editing",
    text: "We fully edit your podcast or interview with stunning visuals, clean transitions, and branded graphics delivered in the perfect format",
  }
];

const otherService = [
  {
    icon: socialMediaVideoIcon,
    name: "Social Media Videos",
    des: "From raw videos to scroll-ready IG Reels and YT Shorts",
    path: "/social-media-videos",
  },
  {
    icon: youtubeVideoIcon,
    name: "YouTube Video Editing",
    des: "Long-form YouTube videos with clean cuts, flow, and branding.",
    path: "/youtube-video-editing",
  },
  {
    icon: corporateVideoIcon,
    name: "Corporate & Business Videos",
    des: "Polished business videos for presentations and internal brand communication",
    path: "/corporate-and-business-video",
  },
  {
    icon: animatedVideoIcon,
    name: "Animated Videos",
    des: "Engaging animated videos that simplify ideas and grab attention.",
    path: "/animated-videos",
  },
  {
    icon: tutorialVideoIcon,
    name: "Explainer & Tutorial Videos",
    des: "Break down complex ideas into simple, easy-to-follow video explanations.",
    path: "/explainer-tutorial-video",
  },
];
const PodcastVideo = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Editing"
        description="Whether it’s a podcast or a filmed interview, your raw footage deserves polish. We trim, sync, and brand your podcast for a final video that feels premium and looks platform-ready."
        heading="Podcast & Interview"
      />
      <NewCommonServiceForm title="Podcast & Interview Editing" items={items} />
      <PodcastVideoContent/>
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default PodcastVideo;
